import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ComponentsModule } from '@mastechnicaegroup/carelinelive-ui';
import { RefreshableResult } from '@mastechnicaegroup/carelinelive-cdk/rx';
import { Client, ClientSingleResponse } from '@lib/api/models/client';
import { GoogleMap, MapAdvancedMarker } from '@angular/google-maps';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';
import { AccordionItemComponent } from '@shared/layout/accordion-item/accordion-item.component';

@Component({
    selector: 'app-client-contact-address',
    imports: [
        AsyncPipe,
        ComponentsModule,
        GoogleMap,
        MapAdvancedMarker,
        ErrorPanelComponent,
        AccordionItemComponent
    ],
    templateUrl: './client-contact-address.component.html',
    standalone: true,
    styleUrl: './client-contact-address.component.scss'
})
export class ClientContactAddressComponent {
    @Input() clientData: RefreshableResult<ClientSingleResponse> | undefined;
    @Output() editContactAddressDetailsEvent: EventEmitter<void> = new EventEmitter<void>();

    protected options: google.maps.MapOptions = {
        zoom: 15,
        mapId: 'carebrokerage-map'
    };

    private map: google.maps.Map | undefined;

    editContactAddressDetails() {
        window.scrollTo(0, 0);
        this.editContactAddressDetailsEvent.emit();
    }

    initMap($event: google.maps.Map, clientData: Client) {
        this.map = $event;
        if (clientData.person.address.lat && clientData.person.address.lng) {
            this.map.setOptions({
                center: { lat: +clientData.person.address.lat, lng: +clientData.person.address.lng }
            });
        }
    }
}
